import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  userProfileData: null,
  moduleList: [],
  role: [],
}

export const userProfileSlice = createSlice({
  name: 'user-profile-slice',
  initialState,
  reducers: {
    setUserProfile: (state, action) => {
      state.userProfileData = action.payload
    },
    setModuleList: (state, action) => {
      state.moduleList = action.payload
    },
    resetUserProfile: (state) => {
      state.userProfileData = initialState.userProfileData
    },
    setRole: (state, action) => {
      state.role = action.payload
    },
  },
})

export const { setUserProfile, resetUserProfile, setRole, setModuleList } = userProfileSlice.actions

export default userProfileSlice.reducer
